module.exports = __webpack_public_path__ + "img/logo_black.89a09f5e.png";